/**
 * Единая точка правды для базового URL API.
 *
 * Используется во всех публичных компонентах (fetch/axios) вместо
 * дублирования `process.env.REACT_APP_API_URL || 'http://localhost:8787'`
 * в каждом файле.
 *
 * Для запросов из админки, требующих JWT, используйте `adminApi`
 * из `src/admin/api.ts` — он оборачивает этот же URL и добавляет
 * заголовок Authorization + 401-перехватчик.
 */
export const API_URL: string =
  process.env.REACT_APP_API_URL || 'http://localhost:8787';
